<adm-charging-station-location-filters
  [searchText]="filters().query"
  [organizationId]="filters().organizationId"
  [departmentId]="filters().departmentId"
  [accessGroupIdentifier]="filters().accessGroupIdentifier"
  [pricePolicyId]="filters().pricePolicyId"
  [locationsWithErrorsInSetup]="filters().locationsWithErrorsInSetup"
  [resetTrigger]="resetAllFiltersTrigger()"
  [isPricePolicyViewer]="isPricePolicyViewer"
  [hiddenFilters]="['organization']"
  (search$)="searchInput($event)"
  (organizationSelected)="onOrganizationSelected($event)"
  (departmentSelected)="onDepartmentSelected($event)"
  (accessGroupSelected)="onAccessGroupSelected($event)"
  (pricePolicySelected)="onPricePolicySelected($event)"
  (locationWithErrorFilterUpdated)="updateLocationWithErrorFilter($event)"
  (resetAllFilters)="resetAllFilters()"></adm-charging-station-location-filters>

<ok-card [loading]="locationsLoading()">
  @if (!locationsLoading() && locations().items.length === 0) {
    <ok-feedback-fail>Der er ingen lokationer at vise for denne organisation.</ok-feedback-fail>
  } @else {
    <ok-expand-list
      [data]="locations().items"
      [sort]="currentSort()"
      [configuration]="locationExpandListConfig()"
      [itemTemplate]="locationItemTemplate"
      [destroyContentOnClose]="true"
      [trackBy]="'identifier'"
      (sortChange)="onSortChange($event)" />
  }
</ok-card>

<ng-template #statusColumnTemplate let-location>
  <div
    class="operation-date"
    [matTooltip]="location.operatingDate ? 'Idriftsat: ' + (location.operatingDate | date: 'short') : 'Ikke idriftsat'">
    @if (location.operatingDate) {
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
    } @else {
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-deactivated"></use></svg>
    }
  </div>
</ng-template>

<ng-template #addressColumnTemplate let-location>
  <div class="col col--address">
    <span>{{ location.address | formatAddress }}</span>
  </div>
</ng-template>

<ng-template #limitedAccessColumnTemplate let-location>
  @if (location.restricted) {
    <ng-container>Ja</ng-container>
  }
  @if (!location.restricted) {
    <ng-container>Nej</ng-container>
  }
</ng-template>

<ng-template #appVisibilityStatusColumnTemplate let-location>
  <div class="col col--app-visibility-status">
    <span>{{ location.appVisibilityStatus | translateLocationStatusEnum }}</span>
  </div>
</ng-template>

<ng-template #locationItemTemplate let-location>
  <ok-card>
    <adm-charging-station-location-details [location]="location" />
  </ok-card>
</ng-template>
